export default __webpack_public_path__ + "static/media/image-cover.2e36e955.jpg";